export default __webpack_public_path__ + "static/media/dashboard.148b89c2.svg";